<template>
	<div class="layout">
		<pubheader :current="current" @openLogin="openLogin"></pubheader>
		<banner v-show="current == 0" @openLogin="openLogin"></banner>
		<router-view></router-view>
		<pubfooter></pubfooter>
		<loginDialog :loginDialog="loginDialog" @closeLogin="closeLogin"></loginDialog>
		<el-dialog :visible="successDialog" :show-close="false" top="280px" width="600px">
			<div class="login-dialog-title">
				<i class="el-icon-circle-check"></i>登录成功
			</div>
			<div class="real" v-if="!realFlag">
				<router-link :to="{path:'/realname',type:1}">去实名认证</router-link>，实名认证后可参与数字藏品竞拍。
			</div>
			<div class="button" v-if="!realFlag">
				<el-button @click="closeSuccess" plain type="danger" round>暂不认证</el-button>
			</div>
		</el-dialog>
		<floatButton :current="current"></floatButton>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'layout',
		data() {
			return {
				current: 0,
				loginDialog: false,
				successDialog: false,
				realFlag: false
			};
		},
		computed: {
			getUserInfo() {
				return this.$store.state.userInfo
			}
		},
		watch: {
			getUserInfo(userInfo) {
				this.username = userInfo.name
			},
			$route(to, from) {
				let path = to.path
				this.disposeRouter(path)
			}
		},
		methods: {
			...mapMutations(['saveUserinfo']),
			openLogin() {
				this.loginDialog = true
			},
			closeLogin(t) {
				this.loginDialog = false
				if (t == 2) return
				this.openSuccess(t)
			},
			openSuccess(t) {
				this.successDialog = true
				this.realFlag = t == 1 ? false : true
				if (!this.realFlag) return
				setTimeout(() => {
					this.successDialog = false
				}, 2000)
			},
			closeSuccess() {
				this.successDialog = false
				location.reload()
			},
			fetchUserInfo() {
				this.$api.frontUserInfo({
					userId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						let userinfo = res.data
						this.saveUserinfo(userinfo)
					}
				})
			},
			disposeRouter(path) {
				let index = ['/index', '/one', '/advance', '/scene', '/guide', '/paper', '/about'].indexOf(path)
				this.current = index
				this.$pub.setStorage('current', index)
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.disposeRouter(this.$route.path)
			if (sessionStorage.getItem('realname')) {
				let t = sessionStorage.getItem('realname')
				this.openSuccess(t)
				sessionStorage.removeItem('realname')
			}
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			// 查询保存
			if (this.$pub.getStorage('current')) {
				this.current = parseInt(this.$pub.getStorage('current'))
			}
			if (this.$store.state.hasLogin) {
				this.fetchUserInfo()
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.login-dialog-title {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		font-size: @vue-font-size-lg;
		color: @vue-text-color-red;

		i {
			margin-top: @vue-spacing-col-sm;
			margin-right: @vue-spacing-row-sm;
		}
	}

	.real {
		width: 100%;
		text-align: center;
		font-size: @vue-font-size-sm + 2;

		a {
			color: #d71418;
		}
	}

	.button {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: @vue-spacing-col-lg;
	}
</style>
